/**
 * Who may open Brand Settings / call club brand APIs (matches backend allowBrandAdminForClub).
 * Super Admin, club Administrator, or club Moderator — not Coach-only / Expert Coach-only.
 */
export function canAccessClubBranding(user) {
  if (!user) return false;
  if (user.isSuperAdmin) return true;
  if (user.type_user_id === 1) return true;
  if (user.hasModeratorRole === true) return true;

  const names = user.all_role_names;
  if (Array.isArray(names)) {
    if (names.includes("Super Admin")) return true;
    if (names.includes("Admin")) return true;
    if (names.includes("Moderator")) return true;
  }

  const roles = user.all_roles;
  if (Array.isArray(roles) && roles.includes("r9")) return true;

  if (user.type_user_id === 2) return true;

  return false;
}

export function sameClubId(a, b) {
  if (a == null || b == null) return false;
  return String(a) === String(b);
}

/**
 * Who may add/replace the club logo used in the header, club card, and emails.
 * Super Admin: any club. Club Admin / Moderator: their own club only.
 */
export function canEditClubLogo(user, targetClubId) {
  if (!canAccessClubBranding(user)) return false;
  if (user.isSuperAdmin || user.type_user_id === 1) return true;
  const names = user.all_role_names;
  if (Array.isArray(names) && names.includes("Super Admin")) return true;
  const roles = user.all_roles;
  if (Array.isArray(roles) && roles.includes("r1")) return true;
  return sameClubId(user.club_id, targetClubId);
}
